/**
 * Flattens `array` a single level deep.
 *
 * @deprecated use `Array#flat` or `Array#flatMap` instead
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
export default function flatten(array) {
    return array.reduce((acc, value) => acc.concat(Array.isArray(value) ? value : [value]), []);
}
